import * as React from "react";
import { createBrowserHistory } from "history";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

// components
import studentHomePage from "./pages/Home/studentHomePage.Component";
import LoginPage from "./pages/Login/loginPage.Component";
import SchoolPage from "./pages/Schools/schoolsPage.Component";
import StudentPage from "./pages/Students/studentsPage.Component";
import TeacherPage from "./pages/Teachers/teachersPage.Component";
import ParentHomePage from "./pages/Home/parentHomePage.Component";

import CalendarPage from "./pages/SingleLesson/scheduleLessons.Component";

// assessment config
import AssessmentConfigPage from "./pages/Assessmentconfig/assessmentConfigPage.Component";

import veryTokenPage from "./pages/SSO/veryTokenPage.Component";

// Landing page
// import LandingPage from './pages/Landing/landingPage.Component';

// single assessment
import SingleAssessmentPage from "./pages/Singleassessment/assessmentPage.Component";

// onboarding
import SetAvatarPage from "./pages/Onboarding/setAvatarPage.Component";
import SetProfilePage from "./pages/Onboarding/setProfilePage.Component";

// display assessments
import AssAssessmentViewPagee from "./pages/Assessments/assessmentViewPage.Component";
import UpgradedAssessmentViewPagee from "./pages/Assessments/upgradedAssessmentViewPage.Component";
import StudentPreAssessmentGuide from "./pages/Onboarding/StudentPreAssessmentGuide.Component";
import AssessmentPreviewiewPage from "./pages/Assessments/assessmentPreviewPage.Component";
// assessment completed
import AssAssessmentCompletedPage from "./pages/Assessments/assessmentCompletedPage.component";
import AssAssessmentResultPage from "./pages/Assessments/assessmentResult.Component";
import ParentAssessmentResultPage from "./pages/Assessments/parentAssessmentResult.Component";

// single lesson
import LessonScreenPage from "./pages/SingleLesson/lessonScreenPage.Component";

// single course
import SingleCoursePage from "./pages/SingleCourse/coursePage.Component";

// packages
import PackagesPage from "./pages/Subscription/packagesPage.Component";

// packages
import CheckoutPage from "./pages/Subscription/checkoutPage.Component";

// packages
import LessonPreviewPage from "./pages/SingleLesson/lessonPreviewPage.Component";
import LessonViewPage from "./pages/SingleLesson/lessonViewPage.Component";

// packages
import ProfilePage from "./pages/Profile/profilePage.Component";
import CreateInteractionWizardPage from "./pages/CreateInteractionWizard/CreateInteractionWizardPage.Component";
import DashboardPage from "./pages/InteractionsDashboard/dashboardPage.Component";
import RecallInteractionTemplatePage from "./pages/RecallInteractionTemplate/RecallInteractionTemplatePage.Component";
import ChooseTutor from "./pages/SingleLesson/chooseTutor.Component";
import CongratulationsComponent from "./pages/Feedback/congratulations.Component";
import LessonSentComponent from "./pages/Feedback/lessonSent.Component";
import LessonAssessmentResult from "./pages/Feedback/lessonAssessmentResult.Component";

// datacenters
import StudentDataCenter from "./pages/DataCenter/Student/StudentDataCenter.Component";
import SchoolDataCenter from "./pages/DataCenter/School/SchoolDataCenter.Component";
import AlertLevelListPage from "./pages/DataCenter/School/AlertLevelListPage/alertLevelListPage.Component";

const SchoolTeacherAlertLevelListPage = (props) => (
  <AlertLevelListPage {...props} userType="teachers" />
);
const SchoolStudentAlertLevelListPage = (props) => (
  <AlertLevelListPage {...props} userType="students" />
);
import TeacherAlertLevelListPage from "./pages/DataCenter/Teacher/AlertLevelListPage/alertLevelListPage.Component";
import ViewUserData from "./pages/DataCenter/School/ViewStudentData/viewStudentData.Component";
const ViewTeacherData = (props) => (
  <ViewUserData {...props} userType="teachers" />
);
const ViewStudentData = (props) => (
  <ViewUserData {...props} userType="students" />
);

import ParentDataCenter from "./pages/DataCenter/Parent/parentDataCenter.Component";
import SearchFilters from "./pages/DataCenter/SearchFilters/searchFilters.Component";
import TeacherSearchFilters from "./pages/DataCenter/SearchFilters/teacherSearchFilters.Component";
import ParentComparisonFilters from "./pages/DataCenter/Parent/ComparisonFilters";
import ParentSearchFilters from "./pages/DataCenter/Parent/SearchFilters";
import TeacherDataCenter from "./pages/DataCenter/Teacher/TeacherDataCenter.Component";
import SchoolPerceptions from "./pages/DataCenter/School/ViewPerceptions/SchoolPerceptions.Component";
import TeachersPerceptions from "./pages/DataCenter/Teacher/TeacherPerceptions.Component";
// help center
import HelpCenter from "./pages/HelpCenter/helpCenter.Component";

// checkout
import CheckoutMembership from "./pages/Subscription/checkoutMembership.Component";
import CheckoutWebinar from "./pages/Subscription/checkoutWebinar.Component";
import CheckoutWebsite from "./pages/Subscription/checkoutWebsite.Component";

// new datacentres
import StudentsDataCentre from "./pages/Students/DataCentre";
import StudentsDataCentreLessonDetails from "./pages/Students/DataCentre/LessonDetails";
import DataCentre from "./pages/DataCenter";
import DataCentreCourseDetails from "./pages/DataCenter/CourseDetails";
const ParentDataCentreCourseDetails = (props) => (
  <DataCentreCourseDetails {...props} isParent={true} />
);
const SchoolDataCentreCourseDetails = (props) => (
  <DataCentreCourseDetails {...props} isSchool={true} />
);
const TeacherDataCentreCourseDetails = (props) => (
  <DataCentreCourseDetails {...props} isTeacher={true} />
);
import SchoolStudentList from "./pages/DataCenter/School/SingleSchool/SingleSchool";
import TeacherSchoolStudentList from "./pages/DataCenter/Teacher/SingleSchool/SingleSchool";

// new admin
import AdminCourseDetails from "./pages/Admin/Courses/SingleCourse/SingleCourse";
import NewAdminCourseDetails from "./pages/Admin/Courses/NewCourseView/CourseBuilder.component";
import AdminCourseLesson from "./pages/Admin/Courses/CourseLesson/CourseLesson";
import AdminInteractionDetails from "./pages/Admin/Interactions/SingleInteraction/SingleInteraction";
import AdminInteractionsList from "./pages/Admin/Interactions/ListInteractions/ListInteractions";
import AdminInteractionCreate from "./pages/Admin/Interactions/CreateInteraction/CreateInteraction";
import AdminInteractionSet from "./pages/Admin/InteractionSets/InteractionSet/InteractionSet";
import AdminAssetCollection from "./pages/Admin/AssetCollections/AssetCollection/AssetCollection";
import AdminLessonDetails from "./pages/Admin/Lessons/SingleLesson/SingleLesson";
import AdminCoursePreview from "./pages/Admin/Courses/CoursePreview/CoursePreview";
import AdminHome from "./pages/Admin/Home/HomePage/HomePage";
import AdminStudentsList from "./pages/Admin/Students/StudentsList/StudentsList";
import AdminInstitutionsList from "./pages/Admin/Schools/SchoolsList/SchoolsList";
import AdminInstitutionSingle from "./pages/Admin/Schools/SingleSchool/SingleSchool";
import AdminMessagesList from "./pages/Admin/Messages/MessagesList/MessagesList";
import AdminTeachersList from "./pages/Admin/Teachers/TeachersList/TeachersList";
import AdminParentsList from "./pages/Admin/Parents/ParentsList/ParentsList";
import AdminAssessmentsList from "./pages/Admin/Assessments/ListAssessments/ListAssessments";
import AdminAutorecommenderConfigList from "./pages/Admin/Autorecommender/ListConfigs/ListConfigs";

import NormalAssessment from "./pages/Admin/Assessments/Assessment/NormalAssessment";

import AdminLessonsList from "./pages/Admin/Lessons/ListLessons/ListLessons";
import AdminCoursesList from "./pages/Admin/Courses/ListCourses/ListCourses";
import AdminSetList from "./pages/Admin/InteractionSets/ListInteractionSets/ListInteractionSets";
import AdminCollectionsList from "./pages/Admin/AssetCollections/ListAssetCollections/ListAssetCollections";
import AdminIconsList from "./pages/Admin/Icons/ListIcons/ListIcons";
import AdminVarsList from "./pages/Admin/SystemVariables/ListVariables/ListVariables";
import AdminTemplatesList from "./pages/Admin/Templates/ListTemplates/ListTemplates";
import AdminTemplateSingle from "./pages/Admin/Templates/SingleTemplate/SingleTemplate";
import AdminReportsList from "./pages/Admin/Reports/ReportsList/ReportsList";

import AdminUserProfilesList from "./pages/Admin/UserProfiles/ListUserProfiles/UserProfilesList";

import AdminUserSubscriptionsList from "./pages/Admin/Subscriptions/ListSubscriptions/SubscriptionsList";

import AdminSingleUserProfile from "./pages/Admin/UserProfiles/SingleUserProfile/SingleProfile";

import AdminSingleSubscription from "./pages/Admin/Subscriptions/SingleSubscription/SingleSubscription";

const ParentsDataCentre = (props) => <DataCentre {...props} isParent={true} />;
const SchoolsDataCentre = (props) => <DataCentre {...props} isSchool={true} />;
const TeacherDataCentre = (props) => <DataCentre {...props} isTeacher={true} />;
import NewAssetCollections from "./pages/Admin/AssetCollections/AssetCollectionsNew/AssetCollections.Component";

// new onboarding
import ParentRegistration from "./pages/Onboard/Parent/Registration/ParentRegistration";
import ParentRegistrationMarketing from "./pages/Onboard/Parent/Registration/ParentRegistrationMarketing";
import AssessmentGuide from "./pages/Onboard/Parent/PreassessmentGuide/ParentPreassessmentGuide.component";
import ChildRegistration from "./pages/Onboard/Parent/ChildRegistration/ChildRegistration";
import SchoolRegistration from "./pages/Onboard/Institution/Registration/SchoolRegistration";
import SchoolRegistrationPackaged from "./pages/Onboard/Institution/Registration/SchoolRegistration";
import PixlRegistration from "./pages/Onboard/Institution/PiXLRegistration/PixlRegistration";
import IndiaRegistration from "./pages/Onboard/Institution/India100k/IndiaRegistration";
import PrePaymentPage from "./pages/Onboard/PrePayment/PrePaymentPage.Component";
import PostPaymentPage from "./pages/Onboard/PostPayment/PostPayment.Component";
import UserEngagement from "./pages/Onboard/UserEngagement/UserJourney/UserEngagementPage.Component";
const StudentOnboarding = (props) => (
  <UserEngagement {...props} isStudent={true} />
);
const ParentOnboarding = (props) => (
  <UserEngagement {...props} isParent={true} />
);
const SchoolOnboarding = (props) => (
  <UserEngagement {...props} isSchool={true} />
);
import Packages from "./pages/Onboard/Packages/Packages.Component";
import SelectOnboardingUser from "./pages/Onboard/UserEngagement/SelectOnboardingUser/SelectOnboardingUser.Component";
import Plexing from "./pages/Onboard/Student/PlexPathways/Plexing.Component";
import OnboardingLesson from "./pages/Onboard/Student/OnboardingLesson/OnboadingLesson.Component";
import Booking from "./pages/Onboard/Calendly/Booking.Component";
const SchoolBooking = (props) => <Booking {...props} isSchool={true} />;

import LessonBuilder from "./pages/Admin/LessonBuilder/LessonBuilder.Component";
import StudentPaymentComponent from "./pages/Onboard/Student/Payment/StudentPayment.Component";
import StudentRegistration from "./pages/Onboard/Student/Registration/StudentRegistration.Component";

// import StudentProfilePage from './pages/Profile/Student/StudentProfilePage.Component';
import NewProfilePage from "./pages/Profile/Parent/ParentProfilePage.Component";
import SchoolProfilePage from "./pages/Profile/School/SchoolProfilePage.Component";
import ResetPasswordComponent from "./pages/ResetPassword/ResetPassword.Component";

const StudentProfilePage = (props) => (
  <NewProfilePage {...props} isStudent={true} />
);
const ParentProfilePage = (props) => (
  <NewProfilePage {...props} isParent={true} />
);

import UpdateSubscription from "./pages/Profile/UpdateSubscription/UpdateSubscription.Component";
const UpdateParentSubscription = (props) => (
  <UpdateSubscription {...props} isParent={true} />
);
const UpdateStudentSubscription = (props) => (
  <UpdateSubscription {...props} isStudent={true} />
);

const InstitutionPurchase = (props) => (
  <PrePaymentPage {...props} isSchool={true} />
);

import SchoolTeacherList from "./pages/Schools/TeacherList/TeacherList.Component";
import TeacherListComponent from "./pages/Schools/TeacherList/TeacherList.Component";

import TeacherMainMenu from "./pages/Teachers/TeacherMenu.Component";
import SchoolMainMenu from "./pages/Schools/SchoolMenu.Component";
import StudentsMainMenu from "./pages/Students/StudentMenu.Component";

import QuickGlance from "./pages/DataCenter/School/QuickGlance/QuickGlance.Component";
import ReportCenter from "./pages/DataCenter/School/ReportCenter/ReportCenter.Component";

import TeacherLearnerActivity from "./pages/DataCenter/Teacher/TeacherLearnerActvity.Component";
import DataCentreMenu from "./pages/DataCenter/School/DataCentreMenu";
import SchoolLearnerActivity from "./pages/DataCenter/School/SchoolLearnerActivity";

// create history object
export const history = createBrowserHistory();

// Primary routes
const Routes = () => (
  <Router>
    <Switch>
      {/* <Route path="/landingpage" component={LandingPage} /> */}
      <Route path="/login" component={LoginPage} />
      <Route path="/admins/home" component={AdminHome} />
      <Route path="/admins/dashboard" component={DashboardPage} />
      <Route
        path="/admins/create-interaction-wizard"
        component={CreateInteractionWizardPage}
      />
      <Route
        path="/admins/recall-interaction-template"
        component={RecallInteractionTemplatePage}
      />
      <Route path="/admins/assessmentconfig" component={AssessmentConfigPage} />
      <Route
        path="/admins/singleassessment/:id"
        component={SingleAssessmentPage}
      />
      <Route path="/admins/singlelesson/:id" component={LessonScreenPage} />
      <Route path="/admins/lessonpreview/:id" component={LessonPreviewPage} />
      <Route path="/students/lessonview/:id" component={LessonViewPage} />
      <Route path="/admins/singlecourse/:id" component={SingleCoursePage} />
      <Route path="/students/home" component={studentHomePage} />
      <Route path="/students/initprofile" component={SetProfilePage} />
      <Route path="/students/profile" component={StudentProfilePage} />
      <Route path="/students/checkout/:id" component={CheckoutPage} />
      <Route path="/students/packages" component={PackagesPage} />
      <Route path="/students/setavatar" component={SetAvatarPage} />
      <Route
        path="/students/assessmentcompleted/:id"
        component={AssAssessmentCompletedPage}
      />
      <Route
        path="/students/preassessmentresult/:designation"
        component={AssAssessmentResultPage}
      />
      <Route
        path="/students/assessment/:id"
        component={AssAssessmentViewPagee}
      />
      <Route
        path="/students/proassessment/:id"
        component={UpgradedAssessmentViewPagee}
      />
      <Route path="/students/calendar" component={CalendarPage} />
      <Route
        path="/students/singlelesson/choosetutor"
        component={ChooseTutor}
      />
      <Route path="/students/lessonpreview" component={LessonPreviewPage} />

      <Route path="/parents/home" component={ParentAssessmentResultPage} />
      <Route
        path="/parents/preassessmentresult/:designation"
        component={ParentAssessmentResultPage}
      />
      <Route
        path="/parents/datacenter/:childid"
        component={ParentDataCenter}
        exact={true}
      />
      <Route path="/parents/datacenter" component={ParentDataCenter} />
      <Route
        path="/parents/preassessmentguide"
        exact={true}
        component={AssessmentGuide}
      />
      <Route path="/parents/initprofile" component={SetProfilePage} />
      <Route path="/parents/setavatar" component={SetAvatarPage} />
      <Route
        path="/parents/assessment/:id"
        component={AssAssessmentViewPagee}
      />
      <Route path="/parents/comparisons" component={ParentComparisonFilters} />
      <Route path="/parents/search-filters" component={ParentSearchFilters} />

      {/* feedback routes */}
      <Route
        path="/students/congratulations"
        component={CongratulationsComponent}
      />
      <Route path="/students/lessonsent" component={LessonSentComponent} />
      <Route
        path="/students/lessonassessmentresult"
        component={LessonAssessmentResult}
      />
      <Route path="/students/datacenter" component={StudentDataCenter} />
      <Route path="/schools/home" component={SchoolDataCenter} />
      <Route path="/schools/studentlist" component={SchoolStudentList} />
      <Route
        path="/schools/students/alertlevel/:id/:asid/:cohort"
        component={SchoolStudentAlertLevelListPage}
      />
      <Route
        path="/schools/teachers/alertlevel/:id/:asid/:cohort"
        component={SchoolTeacherAlertLevelListPage}
      />
      <Route
        path="/teachers/alertlevel/:id/:asid/:cohort"
        component={TeacherAlertLevelListPage}
      />
      <Route
        path="/students/preassessmentguide"
        component={StudentPreAssessmentGuide}
      />
      <Route path="/schools/viewstudentdata/:id" component={ViewStudentData} />
      <Route path="/schools/viewteacherdata/:id" component={ViewTeacherData} />
      <Route path="/teachers/viewstudentdata/:id" component={ViewStudentData} />
      <Route path="/schools/filter" component={SearchFilters} />
      <Route path="/schools/perceptions" component={SchoolPerceptions} />
      <Route path="/teachers/perceptions" component={TeachersPerceptions} />
      <Route path="/helpcenter" component={HelpCenter} />
      <Route path="/checkout-membershipsite" component={CheckoutMembership} />
      <Route path="/checkout-website" component={CheckoutWebsite} />
      <Route path="/checkout-webinar" component={CheckoutWebinar} />

      <Route
        path="/teachers/studentlist"
        component={TeacherSchoolStudentList}
      />
      <Route path="/teachers/menu" component={TeacherMainMenu} />
      <Route path="/schools/menu" component={SchoolMainMenu} />
      <Route path="/students/menu" component={StudentsMainMenu} />

      {/* New Data Centres */}
      <Route
        exact={true}
        path="/students/datacentre"
        component={StudentsDataCentre}
      />
      <Route
        exact={true}
        path="/students/datacentre/lessons/:id"
        component={StudentsDataCentreLessonDetails}
      />
      <Route
        exact={true}
        path="/parents/datacentre"
        component={ParentsDataCentre}
      />
      <Route
        exact={true}
        path="/schools/data-centre-menu"
        component={DataCentreMenu}
      />
      <Route
        exact={true}
        path="/schools/datacentre"
        component={SchoolsDataCentre}
      />
      <Route
        exact={true}
        path="/teachers/datacentre"
        component={TeacherDataCentre}
      />
      <Route
        exact={true}
        path="/parents/datacentre/courses/:id"
        component={ParentDataCentreCourseDetails}
      />
      <Route
        exact={true}
        path="/schools/datacentre/courses/:id"
        component={SchoolDataCentreCourseDetails}
      />
      <Route
        exact={true}
        path="/teachers/datacentre/courses/:id"
        component={TeacherDataCentreCourseDetails}
      />
      <Route exact={true} path="/teachers/home" component={TeacherDataCenter} />
      <Route
        exact={true}
        path="/teachers/filter"
        component={TeacherSearchFilters}
      />
      <Route
        exact={true}
        path="/schools/teachers"
        component={TeacherListComponent}
      />

      {/*new admin */}
      <Route
        exact={true}
        path="/admins/courses/:id"
        component={AdminCourseDetails}
      />
      <Route
        exact={true}
        path="/admins/new_courses/:id"
        component={NewAdminCourseDetails}
      />
      <Route
        exact={true}
        path="/admins/course_lessons/:id"
        component={AdminCourseLesson}
      />
      <Route
        exact={true}
        path="/admins/lessons/:id"
        component={AdminLessonDetails}
      />
      <Route
        exact={true}
        path="/admins/interaction_sets/:id"
        component={AdminInteractionSet}
      />
      <Route
        exact={true}
        path="/admins/interactions/:id"
        component={AdminInteractionDetails}
      />
      <Route
        exact={true}
        path="/admins/old_asset_collections/:id"
        component={AdminAssetCollection}
      />
      <Route
        exact={true}
        path="/admins/course_preview/:id"
        component={AdminCoursePreview}
      />
      <Route
        exact={true}
        path="/admins/interaction_set_list/:id"
        component={AdminInteractionsList}
      />
      <Route
        exact={true}
        path="/admins/students"
        component={AdminStudentsList}
      />
      <Route exact={true} path="/admins/parents" component={AdminParentsList} />
      <Route
        exact={true}
        path="/admins/teachers"
        component={AdminTeachersList}
      />
      <Route
        exact={true}
        path="/admins/messages"
        component={AdminMessagesList}
      />
      <Route
        exact={true}
        path="/admins/institutions"
        component={AdminInstitutionsList}
      />
      <Route exact={true} path="/admins/lessons" component={AdminLessonsList} />
      <Route
        exact={true}
        path="/admins/autorecommender_configs"
        component={AdminAutorecommenderConfigList}
      />
      <Route exact={true} path="/admins/icons" component={AdminIconsList} />
      <Route
        exact={true}
        path="/admins/asset_collections"
        component={AdminCollectionsList}
      />
      <Route exact={true} path="/admins/courses" component={AdminCoursesList} />
      <Route
        exact={true}
        path="/admins/interaction_sets"
        component={AdminSetList}
      />
      <Route
        exact={true}
        path="/admins/system_variables"
        component={AdminVarsList}
      />
      <Route
        exact={true}
        path="/admins/assessments"
        component={AdminAssessmentsList}
      />
      <Route
        exact={true}
        path="/admins/templates"
        component={AdminTemplatesList}
      />
      <Route
        exact={true}
        path="/admins/templates/:id"
        component={AdminTemplateSingle}
      />
      <Route
        exact={true}
        path="/admins/institutions/:id"
        component={AdminInstitutionSingle}
      />
      <Route
        exact={true}
        path="/admins/interactions_creator/:id"
        component={AdminInteractionCreate}
      />
      <Route
        path="/admins/assessmentpreview/:id"
        component={AssessmentPreviewiewPage}
      />

      <Route
        exact={true}
        path="/admins/userprofiles"
        component={AdminUserProfilesList}
      />

      <Route
        exact={true}
        path="/admins/subscriptions"
        component={AdminUserSubscriptionsList}
      />

      <Route
        exact={true}
        path="/admins/userprofiles/:id"
        component={AdminSingleUserProfile}
      />

      <Route
        exact={true}
        path="/admins/subscriptions/:id"
        component={AdminSingleSubscription}
      />

      <Route
        exact={true}
        path="/admins/asset_collections/:id"
        component={NewAssetCollections}
      />

      <Route
        path="/admins/normal_assessments/:id"
        component={NormalAssessment}
      />

      <Route exact={true} path="/admins/reports" component={AdminReportsList} />

      {/* new onboarding */}
      <Route
        exact={true}
        path="/onboarding/register/parent"
        component={ParentRegistration}
      />
      <Route
        exact={true}
        path="/parents/addchild"
        component={ChildRegistration}
      />
      <Route
        exact={true}
        path="/parents/assessmentguide"
        component={AssessmentGuide}
      />
      <Route
        path="/register/school/:packageid"
        component={SchoolRegistrationPackaged}
      />
      <Route path="/register/school" component={SchoolRegistration} />
      <Route path="/register/pixl-school" component={PixlRegistration} />
      <Route path="/register/free-assessment" component={IndiaRegistration} />
      <Route
        path="/register/parent/:packageid"
        component={ParentRegistrationMarketing}
      />
      <Route path="/register/parent" component={ParentRegistrationMarketing} />
      <Route
        path="/parents/purchase/:pkid"
        exact={true}
        component={PrePaymentPage}
      />
      <Route path="/parents/purchase" component={PrePaymentPage} />
      <Route
        path="/schools/purchase"
        exact={true}
        component={InstitutionPurchase}
      />
      <Route
        path="/schools/purchase/:pkid"
        exact={true}
        component={InstitutionPurchase}
      />
      <Route
        exact={true}
        path="/onboarding/postpayment"
        component={PostPaymentPage}
      />
      <Route
        exact={true}
        path="/onboarding/student"
        component={StudentOnboarding}
      />
      <Route
        exact={true}
        path="/onboarding/parent"
        component={ParentOnboarding}
      />
      <Route
        exact={true}
        path="/onboarding/school"
        component={SchoolOnboarding}
      />
      <Route exact={true} path="/onboarding/packages" component={Packages} />
      <Route
        exact={true}
        path="/onboarding/getstarted"
        component={SelectOnboardingUser}
      />
      <Route exact={true} path="/plexing" component={Plexing} />
      <Route
        exact={true}
        path="/plexing/lesson/:difficulty/:id"
        component={OnboardingLesson}
      />
      <Route
        exact={true}
        path="/onboarding/school/booking"
        component={SchoolBooking}
      />
      {/* <Route exact={true} path="/onboarding/parent/booking" component={ParentBooking} /> */}
      <Route
        exact={true}
        path="/students/subscription"
        component={StudentPaymentComponent}
      />
      <Route
        exact={true}
        path="/onboarding/register/student"
        component={StudentRegistration}
      />

      <Route
        exact={true}
        path="/password-reset"
        component={ResetPasswordComponent}
      />

      <Route exact={true} path="/ms-verify" component={veryTokenPage} />

      {/* new profiles */}
      <Route
        exact={true}
        path="/students/profilepage"
        component={StudentProfilePage}
      />
      <Route
        exact={true}
        path="/parents/profilepage"
        component={ParentProfilePage}
      />
      <Route
        exact={true}
        path="/schools/profilepage"
        component={SchoolProfilePage}
      />
      <Route
        exact={true}
        path="/students/updatesubscription"
        component={UpdateStudentSubscription}
      />
      <Route
        exact={true}
        path="/parents/updatesubscription"
        component={UpdateParentSubscription}
      />

      {/* quick glance */}
      <Route exact={true} path="/schools/quickglance" component={QuickGlance} />
      <Route
        exact={true}
        path="/schools/report-center"
        component={ReportCenter}
      />

      {/* teacher assessments */}
      <Route
        path="/teachers/assessment/:id"
        component={AssAssessmentViewPagee}
      />
      <Route path="/teachers/assessment" component={AssAssessmentViewPagee} />

      {/* New Lesson Builder */}
      <Route
        exact={true}
        path="/admins/lessonbuilder/:lessonId"
        component={LessonBuilder}
      />

      {/* Learner activity glance for teachers */}
      <Route
        exact={true}
        path="/teachers/learner-activity"
        component={TeacherLearnerActivity}
      />
      <Route
        exact={true}
        path="/schools/learner-activity"
        component={SchoolLearnerActivity}
      />
      <Route
        exact={true}
        path="/schools/teacherlist"
        component={SchoolTeacherList}
      />
      <Route from="/" component={LoginPage} />
      <Redirect from="/" to="/login" />
    </Switch>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.tsx